/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import { memo } from 'react';

import { Tooltip, Typography } from '@mui/material';

import { createEntitiesItemNewStyles } from './EntitiesItenNew.styles';

type EntitiesItemNewProps = {
  title: string;
  disabledTitle?: string;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
};

export const EntitiesItemNew = memo<EntitiesItemNewProps>(props => {
  const { title, onClick, className = '', disabled = false, disabledTitle } = props;
  const classes = createEntitiesItemNewStyles();
  return (
    <div className={className}>
      <Tooltip title={disabled ? disabledTitle : ''}>
        <div
          className={cx(classes.card, {
            [classes.cardDisabled]: disabled,
          })}
          onClick={!disabled ? onClick : undefined}
          role="button"
          aria-disabled={disabled}
          data-cy={`new-entity-${props.title}`}
        >
          <Typography
            variant="h4"
            component="div"
            className={cx(classes.cardTitle, {
              [classes.cardTitleDisabled]: disabled,
            })}
          >
            +&nbsp;{title}
          </Typography>
        </div>
      </Tooltip>
    </div>
  );
});
